import { fontClassMappings } from "../../app/(site)/_components/SanityGroups/HeadingGroup/helpers/fontClassMappings"

/**
 * Helper function to map font class names to their correct CSS class equivalents.
 *
 * Why? Sometimes we want to use short or custom names for fonts in our code, but the actual CSS classes might be different or more complex.
 * This function takes a string of class names, looks up each one in a mapping, and swaps them out if needed.
 * If a class name isn't in the mapping, it just leaves it as is.
 *
 * Example usage:
 *
 *   <p className={fontClass("heading-5xl-bold")}>Heading</p>
 *   // If "heading-5xl-bold" is mapped, this will output:
 *   // <p class="Trade_Gothic_Header_48_105_0_700_uppercase md:Trade_Gothic_Header_96_100_-1_700_uppercase">Heading</p>
 *
 * This makes it easy to use semantic or short keys in the code, while keeping the actual CSS classes maintainable and consistent.
 */
export function fontClass(input: string | null | undefined): string {
    if (!input) return ""

    return input
        .split(/\s+/)
        .map(cls => fontClassMappings[cls] ?? cls)
        .join(" ")
}
